
import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone } from 'lucide-react';

const ServicesCTA = () => {
  return (
    <section 
      className="relative py-16 bg-brand-charcoal-gray text-white overflow-hidden"
      style={{
        backgroundImage: `url('/lovable-uploads/05712f55-6608-4d58-b71e-fc4dd31ec82a.png')`,
        backgroundSize: '200px 200px',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-brand-charcoal-gray/90"></div>
      
      <div className="relative container mx-auto px-4 text-center z-10">
        <h2 className="text-3xl font-bold mb-6">📞 Schedule a Roofing Consultation Today</h2>
        <p className="text-xl mb-4">
          <strong>Request a free drone scan + moisture inspection</strong>
        </p>
        <p className="text-lg mb-8">
          📍 <strong>Raleigh | Wilson | Rocky Mount | Greenville | New Bern</strong>
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-2xl mx-auto">
          <Button size="lg" className="bg-white text-primary hover:bg-white/90 font-semibold">
            <Phone className="mr-2 h-5 w-5" />
            Call (252) 371-2266
          </Button>
          <Button size="lg" variant="outline" className="border-white/60 bg-white/10 text-white hover:bg-white hover:text-primary font-semibold">
            Email claims@carolinatrophyroofs.com
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesCTA;
